import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { PAYMENT_METHOD_PATH } from '../../../../config/paths';
import { clearPaymentMethod, getPaymentMethod } from '../../../../actions';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import PaymentMethodToolbar from './PaymentMethodToolbar';
import NoDataResource from '../../../common/resource/NoDataResource';
import PaymentMethodBasicInformationResource from './resource/PaymentMethodBasicInformationResource';
import InternalResource from '../../../common/resource/InternalResource';

export const PaymentMethod = ({
  breadcrumbs,
  match: {
    params: { id: paymentMethodId },
  },
  paymentMethod,
  loading,
  dispatchGetPaymentMethod,
  dispatchClearPaymentMethod,
}) => {
  useLayoutEffect(() => {
    dispatchGetPaymentMethod({ paymentMethodId });

    return () => dispatchClearPaymentMethod();
  }, []);

  let content = null;
  let toolbar = null;
  if (loading) content = <Loader />;
  else if (paymentMethod.isEmpty()) {
    content = <NoDataResource returnPage={PAYMENT_METHOD_PATH} />;
  } else {
    const paymentMethodJSON = paymentMethod.toJS();
    content = (
      <>
        <h3>Información Básica</h3>
        <PaymentMethodBasicInformationResource {...paymentMethodJSON} />
        <InternalResource id={paymentMethodJSON.id}
                  createDate={paymentMethodJSON.createDate}
                  lastUpdate={paymentMethodJSON.lastUpdate}/>
      </>
    );
    toolbar = <PaymentMethodToolbar paymentMethodId={paymentMethodJSON.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Método de Pago"
      toolbar={toolbar}
      content={content}
    />
  );
};

PaymentMethod.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  paymentMethod: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetPaymentMethod: PropTypes.func.isRequired,
  dispatchClearPaymentMethod: PropTypes.func.isRequired,
};

PaymentMethod.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Métodos de Pago',
      href: PAYMENT_METHOD_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  paymentMethod: AccountingUnit.PaymentMethod.getIn(['current', 'content']),
  loading: !AccountingUnit.PaymentMethod.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetPaymentMethod: getPaymentMethod,
  dispatchClearPaymentMethod: clearPaymentMethod,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethod);
